import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal right fade",
  id: "multiEditComponentModal",
  tabindex: "-1",
  "aria-labelledby": "multiEditComponentModalLabel",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "headerText",
  id: "multiEditComponentModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "operation" }
const _hoisted_9 = {
  key: 0,
  style: {"position":"relative","z-index":"999999","top":"22rem"}
}
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = { class: "child" }
const _hoisted_12 = { class: "needlesTable" }
const _hoisted_13 = {
  key: 0,
  class: "stitchCode"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { style: {"text-align":"left"} }
const _hoisted_16 = {
  key: 0,
  class: "wastageNote"
}
const _hoisted_17 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_ComboBox = _resolveComponent("ComboBox")!

  return (_ctx.multipleFormat)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDialogClose && _ctx.handleDialogClose(...args)), ["prevent"]))
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", { "aria-hidden": "true" }, [
                  _createElementVNode("i", {
                    class: "fa fa-times",
                    "aria-hidden": "true"
                  })
                ], -1)
              ]))]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_GridLoading)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isCancelButtonClicked)
                    ? (_openBlock(), _createBlock(_component_AlertComponent, {
                        key: 1,
                        onSetWindow: _ctx.showGrid,
                        isCancelButtonClicked: _ctx.isCancelButtonClicked,
                        onHidePopup: _ctx.hidePopup
                      }, null, 8, ["onSetWindow", "isCancelButtonClicked", "onHidePopup"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    style: {"width":"7rem","border-radius":"5px"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
                  }, _toDisplayString(_ctx.$t("editComponent.save")), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("table", _hoisted_12, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("multiEditComponent.stitchCode")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("operationCreateComp.component")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.seamLengthUnit == 0
                              ? _ctx.$t("operationCreateComp.consumption") + " 10 cm"
                              : _ctx.$t("operationCreateComp.consumption") + " 3.94 inch"), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("editComponent.brand")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.ticketTex == "Tkt" ? _ctx.$t("editComponent.tkt") : _ctx.$t("editComponent.tex")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("editComponent.shade")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("editComponent.packageSize")), 1)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentsData, (items, id1) => {
                          return (_openBlock(), _createElementBlock("tbody", { key: id1 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.components, (item, id) => {
                              return (_openBlock(), _createElementBlock("tr", { key: id }, [
                                (id === 0)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(items.stitchTypeCode), 1))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_14)),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(item.needleName), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.consumptionValues[id1]?.[id]), 1),
                                _createElementVNode("td", null, [
                                  (_openBlock(), _createBlock(_component_ComboBox, {
                                    "data-source": _ctx.brands.length ? _ctx.brands : [],
                                    "data-text-field": 'text',
                                    "data-value-field": 'value',
                                    height: 130,
                                    filter: 'contains',
                                    key: 'id',
                                    modelValue: _ctx.componentsData[id1].components[id].brandId,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.componentsData[id1].components[id].brandId) = $event),
                                    value: _ctx.componentsData[id1].components[id].brandId,
                                    onChange: ($event: any) => (_ctx.handleBrandChange($event.sender._cascadedValue, id, id1)),
                                    style: {"font-size":"12px !important","width":"11.5em","box-sizing":"border-box"}
                                  }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value", "onChange"]))
                                ]),
                                _createElementVNode("td", null, [
                                  (_openBlock(), _createBlock(_component_ComboBox, {
                                    "data-source": _ctx.tktTexs.length ? _ctx.tktTexs : [],
                                    "data-text-field": 'text',
                                    "data-value-field": 'value',
                                    height: 130,
                                    filter: 'contains',
                                    key: 'id',
                                    modelValue: _ctx.componentsData[id1].components[id].ticketTex,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.componentsData[id1].components[id].ticketTex) = $event),
                                    onChange: ($event: any) => (_ctx.handleTktTexChange($event.sender._cascadedValue, id, id1)),
                                    onOpen: ($event: any) => (_ctx.getTktTexData(_ctx.componentsData[id1].components[id].brandId, id, id1)),
                                    value: _ctx.componentsData[id1].components[id].ticketTex,
                                    style: {"width":"7em","font-size":"12px !important"}
                                  }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "onChange", "onOpen", "value"]))
                                ]),
                                _createElementVNode("td", null, [
                                  (_openBlock(), _createBlock(_component_ComboBox, {
                                    "data-source": _ctx.shades.length ? _ctx.shades : [],
                                    "data-text-field": 'text',
                                    "data-value-field": 'value',
                                    height: 130,
                                    filter: 'contains',
                                    key: 'id',
                                    modelValue: _ctx.componentsData[id1].components[id].shade,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.componentsData[id1].components[id].shade) = $event),
                                    value: _ctx.componentsData[id1].components[id].shade,
                                    style: {"width":"9.1em","font-size":"12px !important"}
                                  }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value"]))
                                ]),
                                _createElementVNode("td", null, [
                                  (_openBlock(), _createBlock(_component_ComboBox, {
                                    "data-source": _ctx.packageSizes.length ? _ctx.packageSizes : [],
                                    "data-text-field": 'text',
                                    "data-value-field": 'value',
                                    height: 130,
                                    filter: 'contains',
                                    key: 'id',
                                    modelValue: _ctx.componentsData[id1].components[id].packageSize,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.componentsData[id1].components[id].packageSize) = $event),
                                    onOpen: ($event: any) => (_ctx.getPackageSizeData(_ctx.componentsData[id1].components[id].ticketTex, id, id1)),
                                    value: _ctx.componentsData[id1].components[id].packageSize,
                                    style: {"width":"7em","font-size":"12px !important"}
                                  }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "onOpen", "value"]))
                                ])
                              ]))
                            }), 128)),
                            _cache[5] || (_cache[5] = _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                colspan: "7",
                                style: {"height":"20px","background":"transparent"}
                              })
                            ], -1))
                          ]))
                        }), 128))
                      ])
                    ]),
                    (!_ctx.isV4CalculationEngine)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t("styleGrid.threadWastageNote")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        style: {"width":"7rem","border-radius":"5px"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
                      }, _toDisplayString(_ctx.$t("editComponent.save")), 1),
                      _createElementVNode("button", {
                        class: "btn btn-secondary",
                        style: {"width":"8rem","border-radius":"5px"},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isCancelButtonClicked = true))
                      }, _toDisplayString(_ctx.$t("editComponent.cancel")), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}